<template>
  <component v-if="appConfig" :is="temp" />
</template>
<script>
export default {
  components: {
    default1: () => import('~/template/footer/default1'),
  },
  computed: {
    appConfig(){
      return this.$store.state.service.appConfig;
    },
    temp(){
      if(this.appConfig.hasOwnProperty('pc_foot_template')){
        return this.appConfig.pc_foot_template
      }else{
        return ''
      }
    }
  },
  methods: {}
}
</script>

<style lang="less">
</style>
